/**
 * 接口域名的管理
 */
// 正式配置
const base = {

    sq:'/api',//请求代理需要用到
    bd: 'https://four-dls.gycd.net/api',
    // bd: 'http://127.0.0.1:9250',
    client:'https://four-dls.gycd.net',
    appid:'wx2cf888b46e46c976'
}


//演示环境 
// const base = {
//   sq: '/api',//请求代理需要用到
//   bd: 'http://api.huizhidata.com',
//   // bd: 'http://localhost:9090',
//
//   client: 'http://hzqc-dl.huizhidata.com',
//   //慧知公众号
//   appid: 'wxd76606651fd9a4a7'
// }





export default base;


